var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 890.4 216.1",
    style: {
      enableBackground: "new 0 0 890.4 216.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo-negative") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M213.4,0C160.3,0,115,38.7,106.7,91.3V3.4C65,14.2,33.7,48.8,27,91.4V36.6c-36,40.8-36,102,0,142.8v-54.8    c6.6,42.6,38,77.2,79.7,88v-87.9c9.3,58.9,64.5,99.2,123.5,89.9c58.9-9.3,99.2-64.5,89.9-123.5C311.8,38.7,266.6,0,213.4,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M499.9,23.4c-22,0-39.9,7.8-53.7,23.4s-20.8,36.1-20.8,61.6c0,25.8,6.7,46.4,20.2,61.6    c13.5,15.3,31.6,22.9,54.3,22.9c21.7,0,39.4-7.6,53.3-22.7c13.9-15.1,20.8-35.8,20.8-61.9c0-25.5-6.9-46-20.8-61.6    C539.3,31.2,521.6,23.4,499.9,23.4z M537,156.9c-9,11-21.4,16.5-37.2,16.5c-16.8,0-29.5-5.9-38.2-17.7c-8.7-11.8-13-27.6-13-47.3    c0-19.9,4.5-35.8,13.4-47.8c8.9-12,21.5-18,37.8-18c16.2,0,28.7,6.2,37.5,18.5s13.2,28.1,13.2,47.4    C550.6,129.7,546.1,145.9,537,156.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M719.8,72.8c-13.7,0-25.4,6.5-35.2,19.4V27.8h-20v160.7h15.1l4-17.4c3.4,5.8,8.1,10.7,13.8,14.2    c6.1,3.9,13.2,5.9,20.4,5.8c14.7,0,26.6-5.5,35.7-16.5s13.7-25.4,13.7-43.2c0-18-4.6-32.2-13.7-42.8    C744.6,78.1,733.3,72.8,719.8,72.8z M739,162.1c-5.8,7.6-13.8,11.5-24,11.5c-8.2,0-15.1-3.4-20.9-10.2c-5.8-6.8-8.8-15.9-9.1-27.1    v-8.7c0.6-11.6,3.8-20.7,9.6-27.4c5.8-6.7,12.8-10,21.1-10c10.1,0,18,3.7,23.6,11.1s8.5,17.5,8.5,30.3    C747.7,144.3,744.8,154.5,739,162.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 789.7,
    y: 75.4,
    className: "st0",
    width: 20.2,
    height: 113
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M626.5,80.4c-5.3,4.7-9.3,10.6-11.8,17.2l-2.5-22.2h-16.9v113h20.9v-58.7c0.1-6.5,1.2-12.9,3.1-19.1    c1.8-5.3,4-9.2,6.6-11.7c2-2,4.4-3.8,6.9-5.1c1.8-0.9,3.7-1.4,5.7-1.4c4.4,0,6.5,0,10.6,0V73.6c-1.3-0.2-2.7-0.4-4-0.4    C638.3,73.2,631.6,75.7,626.5,80.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M866,42.7l-18.8,14.7v18.7H831v15.8h15.8V163c0,11.7,5.4,25.5,27,25.5c5.6,0,10.6-0.3,16.3-0.3l0.1-15    l-4.8-0.2c-14.2,0-19.2-1.2-19.2-15.6V91.9h24.2V76.1H866V42.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 789.7,
    y: 31.2,
    className: "st0",
    width: 20.2,
    height: 20.2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c5dcc5d1283d1aa7df0399dbfd9a5a2c.svg";
export { ForwardRef as ReactComponent };